import React from "react";
import styles from "./deletedUserUi.module.scss";

type DeletedUserAvatarShellProps = {
  deleted?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

/** Yuvarlak avatar içeriğini sarar; silinmiş kullanıcıda solukluk + koyu overlay */
export function DeletedUserAvatarShell({
  deleted,
  className,
  style,
  children,
}: DeletedUserAvatarShellProps) {
  return (
    <span
      className={`${styles.shell} ${deleted ? styles.shellDeleted : ""} ${className ?? ""}`}
      style={style}
    >
      {children}
      {deleted ? <span className={styles.overlay} aria-hidden /> : null}
    </span>
  );
}

type DeletedUserChipAvatarProps = {
  deleted?: boolean;
  sizePx?: number;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

/** Modal chip / küçük daire harf avatarları için */
export function DeletedUserChipAvatar({
  deleted,
  sizePx = 24,
  className,
  style,
  children,
}: DeletedUserChipAvatarProps) {
  return (
    <span
      className={`${styles.chipAvatarShell} ${deleted ? styles.chipAvatarShellDeleted : ""} ${className ?? ""}`}
      style={{ width: sizePx, height: sizePx, ...style }}
    >
      {children}
      {deleted ? <span className={styles.chipAvatarOverlay} aria-hidden /> : null}
    </span>
  );
}
